import React, { useEffect } from "react";

import { useLocalContent } from "~/sdks/LocalContent/context";

import type { ScoreKey, POISubcategory } from "~/sdks/LocalContent/types";
import type { Markers, MarkerValue } from "./types";

import { Loading } from "./Loading";
import { Subcategories } from "./Subcategories";
import { List } from "./List";

import * as styles from "./styles";

export function ScorePoiList({
  scoreKey,
  isLoading = false,
  showPois = true,
  pois,
  onPOISelected,
}: {
  scoreKey: ScoreKey | null;
  isLoading?: boolean;
  showPois?: boolean;
  pois?: Markers;
  onPOISelected?: (poi: MarkerValue, category: POISubcategory) => void;
}) {
  const { selectedPoiSubcategory, handleSelectPoiSubcategory } =
    useLocalContent();

  useEffect(() => {
    if (
      isLoading ||
      typeof pois === "undefined" ||
      Object.keys(pois).length === 0
    ) {
      handleSelectPoiSubcategory(null);
      return;
    }

    const filteredSubcategories = Object.keys(pois).filter(
      (subcategory) => (pois[subcategory as POISubcategory]?.length ?? 0) > 0
    );

    if (filteredSubcategories.length === 0) {
      handleSelectPoiSubcategory(null);
      return;
    }

    if (selectedPoiSubcategory !== null) {
      return;
    }

    handleSelectPoiSubcategory(filteredSubcategories[0] as POISubcategory);
  }, [pois, isLoading]);

  if (isLoading) {
    return <Loading />;
  }

  if (typeof pois === "undefined" || selectedPoiSubcategory === null) {
    return null;
  }

  return (
    <div className={styles.container}>
      <Subcategories
        pois={pois}
        scoreKey={scoreKey}
        selectedSubcategory={selectedPoiSubcategory}
        onSelectCategory={handleSelectPoiSubcategory}
      />

      {typeof pois[selectedPoiSubcategory] !== "undefined" && (
        <List
          pois={pois[selectedPoiSubcategory]}
          showPois={showPois}
          onSelect={onPOISelected}
        />
      )}
    </div>
  );
}
